import { combineReducers } from 'redux';
import GradeListReducer from './GradeListReducer';
import ViewGradeReducer from './ViewGradeReducer';
import { reducer as JobsInRangeReducer } from '../facets/JobsInRange';

export const SLIDEOUT_STATUS = {
  LIST: 'GradeList',
  VIEW: 'ViewGrade'
};

const structureModelingAnalytics = combineReducers({
  GradeListReducer,
  ViewGradeReducer,
  JobsInRangeReducer
});

export default structureModelingAnalytics;
